import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import InputField from "../../../../Components/Masters/InputField";
import { Box, Button, Typography } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import {
  validateNumberInput,
  validatePercentageInput,
} from "../../../../utils/validateFields";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import CircleIcon from "@mui/icons-material/Circle";
import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI401_3 = ({ hide }) => {
  const questionData = [
    {
      fieldName: "eligibleForParentalLeave",
      title:
        "a. How many employees were eligible for parental leave during the reporting period, categorized by gender?",
    },
    {
      fieldName: "availedParentalLeave",
      title:
        "b. How many employees availed parental leave during the reporting period, categorized by gender?",
    },
    {
      fieldName: "returnedAfterParentalLeave",
      title:
        "c. How many employees returned to work after the conclusion of their parental leave during the reporting period, categorized by gender?",
    },
    {
      fieldName: "returnedWorkAfterParentalLeave",
      title:
        "d. Of the employees who returned to work after parental leave during the reporting period, how many remained employed 12 months after their return, categorized by gender?",
    },
    {
      fieldName: "returnToWork",
      subHeading: "Return to work rate (%)",
      type: "percentage",
      title:
        "e. What were the return-to-work and retention rates of employees who took parental leave during the reporting period, categorized by gender?",
    },
    {
      fieldName: "retentionRates",
      type: "percentage",
      subHeading: "Retention rates of employees (%)",
    },
  ];

  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const [formData, setFormData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const handleStorage = () => {
      setGriReview(JSON.parse(localStorage.getItem("griReview")));
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GRI400`);
      const res1 = res?.data?.data?.GRI400?.parentalLeavesData;
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setFormData({
      eligibleForParentalLeave: data?.eligibleForParentalLeave || {
        female: "",
        male: "",
      },
      availedParentalLeave: data?.availedParentalLeave || {
        female: "",
        male: "",
      },
      returnedAfterParentalLeave: data?.returnedAfterParentalLeave || {
        female: "",
        male: "",
      },
      returnedWorkAfterParentalLeave: data?.returnedWorkAfterParentalLeave || {
        female: "",
        male: "",
      },
      returnToWorkAndRetentionRates: {
        returnToWork: data?.returnToWorkAndRetentionRates?.returnToWork || {
          female: "",
          male: "",
        },
        retentionRates: data?.returnToWorkAndRetentionRates?.retentionRates || {
          female: "",
          male: "",
        },
      },
    });
  }, [data]);

  const handleChange = (field, name, value) => {
    // const { name, value } = e.target;
    if (
      (name === "returnToWork" || name === "retentionRates") &&
      !validatePercentageInput(value)
    )
      return;
    else if (!validateNumberInput(value)) return;

    setErrors((prev) => ({
      ...prev,
      [name]: { ...prev?.[name], [field]: "" },
    }));
    if (name === "returnToWork" || name === "retentionRates") {
      setFormData((prev) => ({
        ...prev,
        returnToWorkAndRetentionRates: {
          ...prev.returnToWorkAndRetentionRates,
          [name]: {
            ...prev?.returnToWorkAndRetentionRates?.[name],
            [field]: value,
          },
        },
      }));
    } else
      setFormData((prev) => ({
        ...prev,
        [name]: { ...prev?.[name], [field]: value },
      }));
  };

  const validateForm = () => {
    const newErrors = {};

    questionData.forEach((el) => {
      // Initialize newErrors[el.fieldName] if it doesn't exist
      if (!newErrors[el.fieldName]) {
        newErrors[el.fieldName] = {};
      }

      if (formData[el.fieldName]?.male === "") {
        newErrors[el.fieldName]["male"] = "Required";
      }
      if (formData[el.fieldName]?.female === "") {
        newErrors[el.fieldName]["female"] = "Required";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // if (!validateForm()) return;
      let transformedData2 = {
        parentalLeavesData: formData,
        type: "GRI400",
        submitted401_3: true,
      };

      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/gri400/402-1/${id}`);
      } catch (error) {
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri400/402-1/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      {!hide && <p className={styles.section_heading}>401 : Material Used</p>}
      <p className={styles.main_heading} style={{ marginBottom: hide ? "-2rem" : "2rem" }}>
        401-3: Parental Leaves
      </p>
      {questionData.map((el) => (
        <Box sx={{ mt: 2 }}>
          <p
            className={styles.ques_heading}
            style={{ textIndent: "-1.1rem", marginLeft: "1.1rem" }}
          >
            {el.title}
          </p>
          {el?.subHeading && (
            <Box sx={{ display: "flex", ml: "1.2rem" }}>
              {" "}
              <CircleIcon sx={{ fontSize: "8px", mt: "1.5rem" }} />{" "}
              <p
                className={styles.ques_heading}
                style={{ marginLeft: "0.5rem" }}
              >
                {el?.subHeading}
              </p>
            </Box>
          )}
          <Box sx={{ width: "60%", display: "flex" }}>
            {["male", "female"].map((field) => (
              <Box sx={{ ml: 2.5, display: "flex", gap: 2, mt: 2 }}>
                <Box sx={{ width: "25%" }}>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: "16px",
                      lineHeight: "24px",
                      fontFamily: "inter",
                    }}
                  >
                    {field === "male" ? "Males" : "Females"}:
                  </Typography>
                </Box>
                <Box sx={{ width: "65%" }}>
                  <InputField
                    placeholder={
                      el?.type === "percentage"
                        ? "Enter Percentage"
                        : "Enter Number"
                    }
                    fieldName={el.fieldName}
                    value={
                      el.fieldName === "returnToWork" ||
                      el.fieldName === "retentionRates"
                        ? formData?.returnToWorkAndRetentionRates?.[
                            el.fieldName
                          ]?.[field]
                        : formData?.[el.fieldName]?.[field]
                    }
                    handleChange={(e) =>
                      handleChange(field, el.fieldName, e.target.value)
                    }
                    mt="-5px"
                    errors={errors[el.fieldName]?.[field] && true}
                    disabled={disabled}
                  />
                  <p
                    color="error"
                    variant="caption"
                    style={{
                      lineHeight: "1.2",
                      margin: "2px 0",
                      marginTop: "5px",
                      color: "#d34040",
                      fontSize: "10px",
                      fontStyle: "italic",
                    }}
                  >
                    {errors[el.fieldName]?.[field]}
                  </p>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      ))}
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI401_3;
